module.exports = __webpack_public_path__ + "img/empty-group-schedule.d9d6716d.svg";